import {combineReducers} from 'redux';
import Auth from './auth/reducers';
import Alert from  './alert/reducer';
import Sport from  './sports/reducres';
import BetSlip from  './betslip/reducers';
// import Fantacy from  './fantacyLogin/reducers';

let reducers = combineReducers({
    Auth,
    Alert,
    Sport,
    BetSlip,
   // Fantacy,
});
export default reducers;
